/**
 * Canonical photography categories — mirror of /app/backend/categories.py.
 *
 * The slug is the database key. Labels are read from i18n.js using `cat_<slug>`
 * keys for the UI; this list provides the iteration order + a fallback English
 * label if the i18n entry is somehow missing.
 */
export const CATEGORIES = [
  { slug: "landscape", en: "Landscape", es: "Paisaje" },
  { slug: "portrait", en: "Portrait", es: "Retrato" },
  { slug: "street", en: "Street", es: "Callejera" },
  { slug: "wildlife", en: "Wildlife", es: "Vida salvaje" },
  { slug: "macro", en: "Macro", es: "Macro" },
  { slug: "still_life", en: "Still Life", es: "Naturaleza muerta" },
  { slug: "product_food", en: "Product & Food", es: "Producto y comida" },
  { slug: "aerial", en: "Aerial & Drone", es: "Aérea y dron" },
  { slug: "architecture", en: "Architecture", es: "Arquitectura" },
  { slug: "black_white", en: "Black & White", es: "Blanco y negro" },
  { slug: "travel", en: "Travel", es: "Viajes" },
  { slug: "night_astro", en: "Night & Astro", es: "Nocturna y astrofotografía" },
  { slug: "nature_flora", en: "Nature & Flora", es: "Naturaleza y flora" },
  { slug: "fine_art", en: "Fine Art", es: "Bellas artes" },
  { slug: "sport_action", en: "Sport & Action", es: "Deporte y acción" },
  { slug: "documentary", en: "Documentary", es: "Documental" },
];

export const CATEGORY_SLUGS = new Set(CATEGORIES.map((c) => c.slug));

export function categoryLabel(slug, lang) {
  const c = CATEGORIES.find((x) => x.slug === slug);
  if (!c) return "";
  return lang === "es" ? c.es : c.en;
}
